import ReactGA from 'react-ga';
export function trackEvent(category, action, label, value = null) {
  ReactGA.event({
    category,
    action,
    label,
    value: Number(value)
  });
}